import { Action, ThunkAction, configureStore } from "@reduxjs/toolkit";
import counterReducer from "../features/counter/counterSlice";
import { api } from "./apiStore";
import authReducer from "./authSlice";
import pageStateReducer from "./pageStateSlice";

export const store = configureStore({
  reducer: {
    counter: counterReducer,
    auth: authReducer,
    pageState: pageStateReducer,
    [api.reducerPath]: api.reducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(api.middleware),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;
